import { useListBaseOpenContracts, TradingContract, useListAccounts } from "@/lib/api/otc";
import { DataTable } from "@/components/ui/DataTable/index";
import { getOtcContractColumns } from "@/section/contracts/shared/OtcContractColumns";
import { useOtcContractHandlers } from "@/section/contracts/shared/useOtcContractHandlers";
import { OtcContractModals } from "@/section/contracts/shared/OtcContractModals";
import { OtcContractFormModal } from "@/section/contracts/shared/OtcContractFormModal";
import { useBearStore } from "@/section/otc/ContractForm";
import { useListCustomers } from "@/lib/api/customer";

export function StagedOtcContracts() {
  const {
    isUnstaging,
    isDeleting,
    unstageModalId,
    deleteModalId,
    setUnstageModalId,
    setDeleteModalId,
    confirmUnstagePrompt,
    confirmDeletePrompt,
    onUnstage,
    onDelete,
  } = useOtcContractHandlers();

  // Fetch staged contracts
  const stagedContractsRes = useListBaseOpenContracts({
    staged_for_review: true,
    filters: {},
  });

  // Fetch customers
  const customersRes = useListCustomers();

  // Fetch accounts
  const accountsRes = useListAccounts(false);

  const stagedContracts = stagedContractsRes?.data?.data || [];
  const isLoading = stagedContractsRes?.isLoading;
  const customers = customersRes?.data?.data || [];
  const accounts = accountsRes?.data?.data || [];

  const set_edit_contract = useBearStore((state) => state.set_edit_contract);

  // Handler for row clicks to open edit modal
  const handleRowClick = (row: TradingContract, _columnId?: string) => {
    set_edit_contract(row);
  };

  // Columns with action buttons for staged contracts
  const columns = getOtcContractColumns({
    showUnstageButton: true,
    showDeleteButton: true,
    onUnstage: (id: string) => confirmUnstagePrompt({ id }),
    onDelete: (id: string) => confirmDeletePrompt({ id }),
  });

  return (
    <div className="w-full">
      <OtcContractModals
        unstageModalId={unstageModalId}
        deleteModalId={deleteModalId}
        setUnstageModalId={setUnstageModalId}
        setDeleteModalId={setDeleteModalId}
        isUnstaging={isUnstaging}
        isDeleting={isDeleting}
        onUnstage={onUnstage}
        onDelete={onDelete}
      />

      {/* Edit Contract Modal */}
      <OtcContractFormModal
        isNew={false}
        customers={customers}
        accounts={accounts}
        refetchContracts={() => stagedContractsRes.refetch()}
      />

      <DataTable
        stickyHeaders
        tableClassName="max-h-[calc(100vh-400px)] overflow-y-scroll"
        data={stagedContracts}
        columns={columns}
        enableSorting
        enableMultiSort
        enableFiltering
        enableGrouping
        filterStyle="select"
        filterMode="internal"
        emptyMessage={
          isLoading ? "Loading..." : "No staged contracts for review"
        }
        rowClickable={true}
        onRowClick={handleRowClick}
      />
    </div>
  );
}
